import { CMS } from "../../components/cms/cms";
import { createStore } from "solid-js/store";
import { Show, onMount } from "solid-js";
import { loadAds, loadChairmansMessageCms, setPageTitle, setSubMenu } from "../../app";

type State = {
    isContentReady: boolean;
}

export function ChairmansMessagePage() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    onMount(async () => {
        await loadChairmansMessageCms();
        await loadAds("8th-arc-salon/chairmans-message");
        setSubMenu("Chairman's Message");
        setPageTitle({ id: "8th-arc-salon/chairmans-message::page-title", text: "Chairman's Message" });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div class="container">
                    <CMS id="8th-arc-salon/chairmans-message::page-body"></CMS>
                </div>
            </Show>
        </>
    )
}